function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}


document.addEventListener('turbo:frame-load', (event) => {
  const { id } = event.target;

  if (id === 'main-product' && window.yotpoWidgetsContainer) {
    window.yotpoWidgetsContainer.initWidgets();
  }

  if (id.startsWith("product-card-") && window.yotpoWidgetsContainer) {
    yotpo.initWidgets()
  }
});

class CartManager {

  static reloadMainCart() {
    if (window.location.pathname == '/cart') {
      window.location.reload();
      return;
    }
    const mainCart = document.getElementById('frame-main-cart');
    if (mainCart) mainCart.reload();
  }

  static reloadCartCount() {
    const cartCount = document.getElementById('frame-cart-count');
    if (cartCount) cartCount.reload();
  }


  static openCart() {
    const cartLink = document.getElementById('cart-link');
    if (cartLink) cartLink.click();
  }

  static async update(updates) {

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      this.reloadCartCount();
      this.reloadMainCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }


}



/**
 * Base component class that implements common functionality
 * for all components
 */
class BaseComponent extends HTMLElement {
    constructor() {
      super();
      this._boundEvents = new Map();
      this.debug = false; // Toggle debug mode
    }

    addSafeEventListener(element, event, handler) {
      const boundHandler = handler.bind(this);
      element.addEventListener(event, boundHandler);
      if (!this._boundEvents.has(element)) {
        this._boundEvents.set(element, []);
      }
      this._boundEvents.get(element).push({ event, handler: boundHandler });
    }

    disconnectedCallback() {
      this._boundEvents.forEach((events, element) => {
        events.forEach(({ event, handler }) => {
          element.removeEventListener(event, handler);
        });
      });
      this._boundEvents.clear();
    }

    findClosest(selector) {
      return this.closest(selector);
    }


    toggleVisibility(element, show) {
      element.classList.toggle('hidden', !show);
    }

    log(message, data = null, type = 'log') {
      if (!this.debug) return;
      console[type](message, data);
    }

  }



customElements.define('video-component', class VideoComponent extends BaseComponent {

  constructor() {
    super();
    this.video = this.querySelector('video');
    this.toggle = this.querySelector('[data-video-toggle]');

    this.playSVG = this.querySelector('[data-play-svg]');
    this.pauseSVG = this.querySelector('[data-pause-svg]');

    if (this.playSVG) this.video.removeAttribute("controls");
  }

  connectedCallback() {
    this.addSafeEventListener(this.toggle, 'click', this.toggleVideo);
  }

  toggleVideo(event) {
    event.preventDefault();
    if (this.video.paused) {
      this.video.play();
      this.playSVG.classList.add('hidden');
      this.pauseSVG.classList.remove('hidden');
    } else {
      this.video.pause();
      this.playSVG.classList.remove('hidden');
      this.pauseSVG.classList.add('hidden');
    }
  }


});

customElements.define('product-form', class ProductForm extends BaseComponent {

    constructor() {
      super();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      //this.quantityInput = this.querySelector('input[name="quantity"]');
    }

    connectedCallback() {
      this.addSafeEventListener(this.form, 'submit', this.handleSubmit);

    }

    setButtonLoading(isLoading) {
      if (!this.button) return;

      // Store original text if not already stored
      if (!this.button.dataset.originalText) {
        this.button.dataset.originalText = this.button.innerHTML;
      }

      if (isLoading) {
        this.button.disabled = true;
        this.button.classList.add('opacity-50', 'cursor-not-allowed');
        this.button.innerHTML = "Adding...";
      } else {
        this.button.disabled = false;
        this.button.classList.remove('opacity-50', 'cursor-not-allowed');
        this.button.innerHTML = this.button.dataset.originalText;
      }
    }

    handleSubmit = (event) => {
      event?.preventDefault();

      const data = new FormData(this.form);

      console.log(this.dataset);

      const openCart = this.dataset.openCart || 'true';

      this.setButtonLoading(true);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: data
      })
      .then(data => {
        CartManager.reloadCartCount();
        CartManager.reloadMainCart();
        if (openCart == 'true') CartManager.openCart();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.setButtonLoading(false);
      });


    }
});


  class KeyboardManager {

    constructor(component) {
      this.component = component;
      this.lastActiveElement = null;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
    }


    engage() {
      this.lastActiveElement = document.activeElement;
      document.addEventListener('keydown', this.onKeyDown);
      //document.addEventListener('keyup', this.onKeyUp);
      document.querySelector('body').style.overflow = 'hidden';

      requestAnimationFrame(() => this.focusFirstElement());
    }


    disengage() {
      document.removeEventListener('keydown', this.onKeyDown);
      //document.removeEventListener('keyup', this.onKeyUp);
      document.querySelector('body').style.overflow = '';

      // Restore previous focus
      if (this.lastActiveElement) {
        this.lastActiveElement.focus();
        this.lastActiveElement = null;
      }

    }

    onKeyUp(event) {
      if (event.key === 'Tab') console.log(document.activeElement);
    }


    onKeyDown(event) {
      if (event.key === 'Escape' && typeof this.component.close === 'function') {
        this.component.close();
        return;
      }

      if (event.key === 'Tab') {
        this.handleTabKey(event);

      }
    }

    handleTabKey(event) {

      const focusableElements = this.getFocusableElements();

      if (!focusableElements.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }


    getFocusableElements() {
      return Array.from(this.component.querySelectorAll(
        "summary, a, button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )).filter(el => this.isElementFocusable(el));
    }

    focusFirstElement() {
      const focusableElements = this.getFocusableElements();
      if (focusableElements.length) focusableElements[0].focus();
    }



    isElementFocusable(element) {
      if (!element || element.hasAttribute('disabled') || element.hasAttribute('hidden')) {
        return false;
      }

      return true;

      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);

    }

    destroy() {
      this.disengage();
    }
  }




  /**
   * Base class for components that need to handle toggling states
   */
  class ToggleComponent extends BaseComponent {

    constructor() {
      super();
      this.trigger = this.querySelector('[data-trigger]');
      this.content = this.querySelector('[data-content]');
      this.overlay = this.querySelector('[data-overlay]');
      this.closeBtns = this.querySelectorAll('[data-close]');

    }

    connectedCallback() {
      if (!this.trigger || !this.overlay) return;

      this.keyboardManager = new KeyboardManager(this);

      this.addSafeEventListener(this.trigger, 'click', this.toggle);
      this.closeBtns.forEach(btn => this.addSafeEventListener(btn, 'click', this.close));

    }


    toggle(event) {
      event?.preventDefault();
      this.isOpen() ? this.close(event) : this.open(event);
    }


    open(event) {
      event?.preventDefault();
      this.trigger?.setAttribute('aria-expanded', 'true');
      this.toggleVisibility(this.overlay, true);

      if (this.hasAttribute('trap-focus')) this.keyboardManager.engage();
      if (this.hasAttribute('close-on-click')) document.addEventListener('click', this.handleOutsideClick.bind(this));

    }

    handleOutsideClick(event) {

      if (!this.isOpen()) return;

      const isOutsideClick = !this.content?.contains(event.target) && !this.trigger?.contains(event.target);

      if (isOutsideClick) this.close();
    }


    close(event) {
      event?.preventDefault();
      event?.stopPropagation();
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.toggleVisibility(this.overlay, false);

      if (this.hasAttribute('trap-focus')) this.keyboardManager.disengage();
      if (this.hasAttribute('close-on-click')) document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }


    isOpen() {
      return this.trigger?.getAttribute('aria-expanded') === 'true';
    }


    disconnectedCallback() {
      super.disconnectedCallback();
      this.keyboardManager.destroy();
    }

  }

  customElements.define('toggle-component', ToggleComponent);

  customElements.define('modal-component', class ModalComponent extends ToggleComponent {
    constructor() {
      super();
    }

  });


  customElements.define('video-modal', class VideoModal extends ToggleComponent {

    constructor() {
      super();
      this.video = this.querySelector('video');
    }

    open() {
      super.open();
      this.video.play();
    }

    close() {
      super.close();
      this.video.pause();
    }
  });




  customElements.define('drawer-component', class DrawerComponent extends ToggleComponent {

    constructor() {
      super();
      this.trigger = document.querySelector(this.getAttribute('trigger'));
    }

    open() {
      super.open();

      setTimeout(() => {
        this.content.classList.remove('translate-x-full');
      }, 100);

    }

    close() {
      this.content.classList.add('translate-x-full');

      setTimeout(() => {
        super.close();
      }, 700);
    }

  });




  customElements.define('tab-component', class TabComponent extends ToggleComponent {

    constructor() {
      super();
      this.tabs = this.closest('.shopify-section').querySelectorAll('tab-component');
    }

    open() {

      this.tabs.forEach(tab => {
        if (tab !== this && tab.isOpen()) tab.close();
      });

      super.open();
    }
  });



  customElements.define('content-cycle', class ContentCycle extends BaseComponent {

    constructor() {
      super();
      this.contents = this.querySelectorAll('[data-content]');
      this.interval = null;
      this.activeIndex = 0;
      this.speed = parseInt(this.getAttribute('data-speed')) || 5000;
    }

    connectedCallback() {
      this.addSafeEventListener(this, 'mouseover', this.focusInHandling);
      this.addSafeEventListener(this, 'mouseleave', this.focusOutHandling);

      this.play();
    }

    disconnectedCallback() {
      this.stop();
      super.disconnectedCallback();
    }

    play() {

      if (this.contents.length < 2) return;

      this.interval = setInterval(() => {

          const nextIndex = this.activeIndex === (this.contents.length-1) ? 0 : this.activeIndex + 1

          this.toggleVisibility(this.contents[this.activeIndex], false);
          this.toggleVisibility(this.contents[nextIndex], true);

          this.activeIndex = nextIndex;

      }, this.speed);
    }


    stop() {
        clearInterval(this.interval);
    }

    focusOutHandling(event) {
      this.play();
    }

    focusInHandling(event) {
        this.stop();
    }

  });


  /**
 * SubscriptionBox Component
 * Handles subscription and one-time purchase options for products
 */
  customElements.define('subscription-box', class SubscriptionBox extends BaseComponent {
    connectedCallback() {
      this.variantId = this.dataset.variantId;
      this.planDefault = this.dataset.planDefault;

      this.purchaseOptions = this.querySelectorAll(`[name="purchase-type-${this.variantId}"]`);
      this.planSelector = this.querySelector('[data-plan-selector]');
      this.planWrapper = this.querySelector('[data-plan-wrapper]');

      if (!this.purchaseOptions.length || !this.planSelector || !this.planWrapper) {
        console.warn('Subscription box missing required elements');
        return;
      }

      this.setupEventListeners();
      this.initializeState();
    }

    setupEventListeners() {
      this.purchaseOptions.forEach(option => {
        this.addSafeEventListener(option, 'change', this.handlePurchaseTypeChange);
      });
    }

    initializeState() {
      // Check if any option is pre-selected
      const selectedOption = Array.from(this.purchaseOptions)
        .find(option => option.checked);

      if (selectedOption) {
        this.updatePlanVisibility(selectedOption.value);
      }
    }

    handlePurchaseTypeChange = (event) => {
      this.updatePlanVisibility(event.target.value);
    }

    updatePlanVisibility(purchaseType) {
      if (purchaseType === 'otp') {
        this.planWrapper.style.display = 'none';
        this.planSelector.value = '';
      } else if (purchaseType === 'subscription') {
        this.planWrapper.style.display = 'block';
        this.planSelector.value = this.planDefault;
      }
    }
  });


  /**
 * Enhanced Layout Component with improved sliding functionality
 */
/**
 * Enhanced Layout Component with Debug
 */
customElements.define('cjs-layout', class CJSLayout extends BaseComponent {
  constructor() {
    super();
    this._scrollAmount = 0;
    this.resizeObserver = null;

    this.log('Constructor initialized');
  }


  connectedCallback() {
    this.log('Component connecting...');

    try {
      this.track = this.querySelector('[data-cjs-track]');
      this.prev = this.querySelector('[data-cjs-prev]');
      this.next = this.querySelector("[data-cjs-next]");


      if (!this.track || !this.prev || !this.next) {
        this.logError('Required elements missing', {
          track: !!this.track,
          prev: !!this.prev,
          next: !!this.next
        });
        return;
      }

      // Get scroll configuration from data attributes
      this.scrollBy = this.getAttribute('data-scroll-by') || 'item';
      this.scrollBehavior = this.getAttribute('data-scroll-behavior') || 'smooth';

      this.log('Configuration', {
        scrollBy: this.scrollBy,
        scrollBehavior: this.scrollBehavior,
        trackWidth: this.track.scrollWidth,
        visibleWidth: this.track.clientWidth
      });

      this.setupNavigation();
      this.setupScrollListener();
      this.setupResizeObserver();

      // Initial state update
      this.updateButtonStates();
    } catch (error) {
      this.log('Error in connectedCallback', error, 'error');
    }
  }

  disconnectedCallback() {
    this.log('Component disconnecting...');
    try {
      super.disconnectedCallback();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    } catch (error) {
      this.log('Error in disconnectedCallback', error);
    }
  }

  setupResizeObserver() {
    this.log('Setting up ResizeObserver');
    try {
      this.resizeObserver = new ResizeObserver((entries) => {
        this.log('Resize detected', {
          contentRect: entries[0].contentRect
        });
        this.updateButtonStates();
      });
      this.resizeObserver.observe(this.track);
    } catch (error) {
      this.log('Error setting up ResizeObserver', error);
    }
  }

  setupScrollListener() {
    this.log('Setting up scroll listener');
    let scrollTimeout;
    this.addSafeEventListener(this.track, 'scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const metrics = this.getScrollMetrics();
        this.log('Scroll event fired', metrics);
        requestAnimationFrame(() => this.updateButtonStates());
      }, 150);
    });
  }

  setupNavigation() {
    this.log('Setting up navigation buttons');
    this.addSafeEventListener(this.prev, 'click', (e) => {
      e.preventDefault();
      const canScroll = this.canScrollPrev();
      this.log('Previous button clicked', { canScroll });
      if (canScroll) {
        this.scrollPrev();
      }
    });

    this.addSafeEventListener(this.next, 'click', (e) => {
      e.preventDefault();
      const canScroll = this.canScrollNext();
      this.log('Next button clicked', { canScroll });
      if (canScroll) {
        this.scrollNext();
      }
    });
  }

  getScrollMetrics() {
    const { scrollLeft, clientWidth, scrollWidth } = this.track;
    let itemWidth = 0;

    if (this.scrollBy === 'item') {
      // Get all content elements, excluding style tags and text nodes
      const contentElements = Array.from(this.track.children).filter(
        child => child.nodeType === 1 && child.tagName !== 'STYLE'
      );

      if (contentElements.length > 0) {
        itemWidth = contentElements[0].offsetWidth;
      }
    }

    return {
      scrollLeft,
      clientWidth,
      scrollWidth,
      itemWidth
    };
  }

  canScrollPrev() {
    const { scrollLeft } = this.getScrollMetrics();
    const canScroll = scrollLeft > 0;
    this.log('Can scroll previous?', { canScroll, scrollLeft });
    return canScroll;
  }

  canScrollNext() {
    const { scrollLeft, clientWidth, scrollWidth } = this.getScrollMetrics();
    const canScroll = scrollLeft + clientWidth < scrollWidth;
    this.log('Can scroll next?', {
      canScroll,
      scrollLeft,
      clientWidth,
      scrollWidth,
      remaining: scrollWidth - (scrollLeft + clientWidth)
    });
    return canScroll;
  }

  calculateScrollAmount() {
    const { clientWidth, itemWidth } = this.getScrollMetrics();
    return this.scrollBy === 'item' ? itemWidth : clientWidth;
  }

  scrollPrev() {
    if (!this.track) {
      this.log('Track element missing', null, 'error');
      return;
    }

    const scrollAmount = this.calculateScrollAmount();
    if (scrollAmount === 0) {
      this.log('Scroll amount is 0, cannot scroll', null, 'error');
      return;
    }

    const currentScroll = this.track.scrollLeft;
    const targetScroll = Math.max(0, currentScroll - scrollAmount);

    this.log('Scrolling previous', {
      from: currentScroll,
      by: -scrollAmount,
      to: targetScroll
    });

    requestAnimationFrame(() => {
      this.track.scrollTo({
        left: targetScroll,
        behavior: this.scrollBehavior
      });
    });
  }

  scrollNext() {
    if (!this.track) {
      this.log('Track element missing', null, 'error');
      return;
    }

    const scrollAmount = this.calculateScrollAmount();
    if (scrollAmount === 0) {
      this.logError('Scroll amount is 0, cannot scroll');
      return;
    }

    const { scrollLeft, clientWidth, scrollWidth } = this.getScrollMetrics();
    const maxScroll = scrollWidth - clientWidth;
    const targetScroll = Math.min(maxScroll, scrollLeft + scrollAmount);

    this.log('Scrolling next', {
      from: scrollLeft,
      by: scrollAmount,
      to: targetScroll,
      maxScroll,
      scrollWidth,
      clientWidth
    });

    requestAnimationFrame(() => {
      this.track.scrollTo({
        left: targetScroll,
        behavior: this.scrollBehavior
      });
    });
  }

  updateButtonStates() {
    try {
      const canScrollPrev = this.canScrollPrev();
      const canScrollNext = this.canScrollNext();

      this.log('Updating button states', {
        canScrollPrev,
        canScrollNext,
        metrics: this.getScrollMetrics()
      });

      this.updateButtonState(this.prev, canScrollPrev);
      this.updateButtonState(this.next, canScrollNext);

      this.dispatchEvent(new CustomEvent('scroll-state-change', {
        detail: { canScrollPrev, canScrollNext }
      }));
    } catch (error) {
      this.log('Error updating button states', error, 'error');
    }
  }

  updateButtonState(button, canScroll) {
    try {
      const buttonType = button === this.prev ? 'prev' : 'next';
      this.log(`Updating ${buttonType} button state`, { canScroll });

      // Update button classes and state
      button.classList.toggle('opacity-50', !canScroll);
      button.classList.toggle('cursor-not-allowed', !canScroll);
      button.setAttribute('aria-disabled', (!canScroll).toString());
      button.disabled = !canScroll;
    } catch (error) {
      this.log('Error updating button state', error, 'error');
    }
  }
});


customElements.define('media-component', class MediaComponent extends BaseComponent {

  constructor() {
      super();

  }


  connectedCallback() {

      this.poster = this.querySelector('a');

      if (!this.poster) return;

      this.template = this.querySelector('template');

      this.addSafeEventListener(this.poster, 'click', this.loadContent.bind(this));

  }


  loadContent(event) {

      //window.pauseAllMedia();

      event.preventDefault();

      if (!this.getAttribute('loaded')) {

          const content = document.createElement('div');

          const newNode = this.template.content.firstElementChild.cloneNode(true);

          content.appendChild(newNode);

          this.setAttribute('loaded', true);

          const media = content.querySelector('video, model-viewer, iframe')

          this.poster.appendChild(media).focus();

      }
  }

})

/**
 * CJSMedia Component
 * Handles lazy loading of media content (video, model-viewer, iframe)
 * with automatic video pause when hidden
 */
customElements.define('cjs-media', class CJSMedia extends BaseComponent {
    constructor() {
      super();
      this.observer = null;
      this.mediaElement = null;
    }

    connectedCallback() {
      this.poster = this.querySelector('a');
      this.template = this.querySelector('template');

      if (!this.poster || !this.template) {
        console.warn('CJS Media: Missing required elements (poster or template)');
        return;
      }

      this.addSafeEventListener(this.poster, 'click', this.loadContent);

      // Setup intersection observer for visibility changes
      this.setupVisibilityObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      if (this.observer) {
        this.observer.disconnect();
      }
      this.stopMedia();
    }

    setupVisibilityObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            this.stopMedia();
          }
        });
      }, {
        threshold: 0
      });

      this.observer.observe(this);
    }

    loadContent = (event) => {
      event.preventDefault();

      if (this.hasAttribute('loaded')) return;

      try {
        // Create container for the new content
        const content = document.createElement('div');

        // Clone the template content
        const mediaContent = this.template.content.firstElementChild.cloneNode(true);

        // Add the cloned content to the container
        content.appendChild(mediaContent);

        // Find the media element
        const media = content.querySelector('video, model-viewer, iframe');

        if (!media) {
          console.warn('CJS Media: No valid media element found in template');
          return;
        }

        // Store reference to media element
        this.mediaElement = media;

        // Insert the media before the poster
        const insertedMedia = this.insertBefore(media, this.poster);

        // Remove the poster
        this.poster.remove();

        // Mark as loaded
        this.setAttribute('loaded', '');

        // Focus and play if it's a video
        insertedMedia.focus();
        if (this.isVideo()) {
          insertedMedia.play();
        }

        // Add visibility change listener
        this.addSafeEventListener(this, 'visibilitychange', () => {
          if (document.hidden) {
            this.stopMedia();
          }
        });
      } catch (error) {
        console.error('CJS Media: Error loading content', error);
      }
    }

    isVideo() {
      return this.mediaElement instanceof HTMLVideoElement;
    }

    stopMedia() {
      if (this.mediaElement && this.isVideo()) {
        try {
          this.mediaElement.pause();
          // Reset video to start
          this.mediaElement.currentTime = 0;
        } catch (error) {
          console.warn('CJS Media: Error stopping video', error);
        }
      }
    }

    /**
     * Public method to stop media playback
     * Can be called from outside the component
     */
    stop() {
      this.stopMedia();
    }
  });



 /**
 * ContentToggle Component
 * Handles toggling between different content sections
 * and manages media playback
 */
customElements.define('content-toggle', class ContentToggle extends BaseComponent {
    connectedCallback() {
      this.section = this.findClosest('section');
      if (!this.section) return;

      this.toggles = Array.from(this.section.querySelectorAll('content-toggle'));
      this.links = this.querySelectorAll('[data-toggle]');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.links.forEach(link => {
        this.addSafeEventListener(link, 'click', this.handleToggle);
      });
    }

    handleToggle = (event) => {
      event.preventDefault();

      const toggleIndex = parseInt(event.currentTarget.getAttribute('data-toggle'));
      const targetContent = this.toggles[toggleIndex];

      if (!targetContent) {
        console.warn('Content Toggle: Target content not found');
        return;
      }

      // Hide all content toggles and stop media in the section
      this.toggles.forEach((content) => {
        this.stopMediaInContent(content);
        this.toggleVisibility(content, false);
      });

      // Show the target content
      this.toggleVisibility(targetContent, true);

      // Update active states on toggle buttons
      this.updateActiveStates(event.currentTarget);
    }

    /**
     * Stops any playing media within a content element
     */
    stopMediaInContent(content) {
      const mediaElements = content.querySelectorAll('cjs-media');
      mediaElements.forEach(media => {
        if (typeof media.stop === 'function') {
          media.stop();
        }
      });
    }

    toggleVisibility(element, show) {
      element.classList.toggle('hidden', !show);
    }

    updateActiveStates(activeLink) {
      // Remove active state from all links
      this.links.forEach(link => {
        link.classList.remove('text-blue-600', 'border-blue-600', 'border-b-2');
      });

      // Add active state to clicked link
      activeLink.classList.add('text-blue-600', 'border-blue-600', 'border-b-2');
    }
  });






  /**
 * CJSTextAnimate Component
 * Animates through a list of words with smooth transitions
 */
customElements.define('cjs-text-animate', class CJSTextAnimate extends BaseComponent {
    constructor() {
      super();
      this.activeIndex = 0;
      this.animationInterval = null;
    }

    connectedCallback() {
      const wordsAttribute = this.getAttribute('data-words');
      if (!wordsAttribute) {
        console.warn('CJS Text Animate: No words provided in data-words attribute');
        return;
      }

      this.words = wordsAttribute.split(',').map(word => word.trim());
      if (this.words.length < 2) {
        console.warn('CJS Text Animate: At least 2 words are required for animation');
        return;
      }

      this.startAnimation();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.stopAnimation();
    }

    startAnimation() {
      // Initial render
      this.render();

      // Start the animation loop
      this.animationInterval = setInterval(() => {
        this.updateAnimation();
      }, 1000);
    }

    stopAnimation() {
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    }

    updateAnimation() {
      const nextIndex = (this.activeIndex + 1) % this.words.length;
      const upcomingIndex = (nextIndex + 1) % this.words.length;

      this.activeIndex = nextIndex;
      this.render(this.words[this.activeIndex], this.words[upcomingIndex]);
    }

    render() {
      const current = this.words[this.activeIndex];
      const next = this.words[(this.activeIndex + 1) % this.words.length];
      const upcoming = this.words[(this.activeIndex + 2) % this.words.length];

      const html = `
        <span class="animate-word animate-out">${current}</span>
        <span class="animate-word animate-in active">${next}</span>
        <span class="animate-word">${upcoming}</span>
      `;

      this.innerHTML = html;
    }


    updateWords(newWords) {
      this.stopAnimation();
      this.words = newWords.split(',').map(word => word.trim());
      this.activeIndex = 0;
      this.startAnimation();
    }
  });




  if (!customElements.get('turret-slider-snap')) {
    customElements.define('turret-slider-snap', class TurretSliderSnap extends HTMLElement {


        constructor() {
            super();
        }


        connectedCallback() {
            this.nextButton = this.querySelector('[data-next]');
            this.prevButton = this.querySelector('[data-prev]');

            this.track = this.querySelector('[data-track]');

            this.activeSlide = 0;


            this.slides = Array.from(this.querySelectorAll('[data-slide]'))
            this.sliderDots = Array.from(this.querySelectorAll('[data-dot]'))

            this.maxSlides = 0

            this.calculateMaxSlides();

            this.behavior = this.getAttribute('behavior') || 'smooth';

            if (this.nextButton) this.nextButton.addEventListener('click', this.next.bind(this));

            if (this.prevButton) this.prevButton.addEventListener('click', this.previous.bind(this));


            this.speed = this.getAttribute('speed') || 5000;

            this.autoplaySpeed = this.getAttribute('autoplay') || 0;

            this.autoplay = null;


            this.sliderDots.forEach((dot, index) => dot.addEventListener('click', this.move.bind(this, index)));

            this.track.addEventListener('scroll', () => this.updateUI.bind(this));


            this.addEventListener('mouseover', this.focusInHandling.bind(this));
            this.addEventListener('mouseleave', this.focusOutHandling.bind(this));


            this.updateUI();
        }



        calculateMaxSlides() {
            this.sliderDots.forEach((dot) => {
                const computed = window.getComputedStyle(dot).display
                if (computed != 'none') this.maxSlides++;
            })
        }



        move(slide) {

            if (!this.slides[slide]) return;

            if (slide > this.maxSlides-1) return;

            const pos = this.track.clientWidth * slide;

            this.activeSlide = slide;

            this.track.scrollTo({
              left: pos,
              behavior: this.behavior
            });

            //this.track.scrollBy(this.slides[slide].clientWidth, 0)

            this.updateUI();
        }


        next(event) {
            event.preventDefault();

            this.move(this.activeSlide + 1);

        }

        previous(event) {
            event.preventDefault();

            this.move(this.activeSlide - 1);
        }


        canSlide() {
            const width = this.track.getBoundingClientRect().width
            if (width < 1) return 1;

            return (width / this.track.clientWidth) > this.activeSlide+1
        }




        updateUI() {

            const next = this.slides[this.activeSlide + 1]
            const prev = this.slides[this.activeSlide - 1]

            const activeDot = this.sliderDots[this.activeSlide]

            const hasNext = (next !== undefined) && (this.activeSlide + 1) <= this.maxSlides-1;

            if (this.nextButton) this.nextButton.classList.toggle('tt-opacity-100', hasNext)
            if (this.prevButton) this.prevButton.classList.toggle('tt-opacity-100', prev !== undefined)


            this.sliderDots.forEach((dot) => {
                dot.classList.toggle('tt-opacity-100', dot === activeDot);
            })
        }


        disconnectedCallback() {
            this.removeEventListener('mouseover', this.focusInHandling.bind(this));
            this.removeEventListener('mouseleave', this.focusOutHandling.bind(this));
            this.pause();
        }


        shouldAutoplay() {
            return this.autoplaySpeed > 0
        }


        play() {

            if (!this.shouldAutoplay()) return;

            if (this.slides.length < 2) return;

            this.track.setAttribute('aria-live', 'off');


            this.autoplay = setInterval(() => {

                const slide = this.activeSlide === (this.slides.length-1) ? 0 : this.activeSlide + 1

                this.move(slide);

            }, this.autoplaySpeed);
        }



        pause () {

            if (!this.shouldAutoplay()) return;

            this.track.setAttribute('aria-live', 'polite');


            clearInterval(this.autoplay);

        }

        focusOutHandling(event) {
            this.play();
        }

        focusInHandling(event) {
            this.pause();
        }


    })
}
